module.exports = __webpack_public_path__ + "img/ddd.80767a99.png";